import { useV2ListServiceAccountCredentialsQuery } from "@generated";
import { ClientCredential } from "../types";

interface ListClientCredentialsResult {
  credentials: ClientCredential[];
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
  refetch: () => void;
}

const useListClientCredentials = (
  userId: number
): ListClientCredentialsResult => {
  const { data, isLoading, isFetching, error, refetch } =
    useV2ListServiceAccountCredentialsQuery(
      { userId },
      { refetchOnMountOrArgChange: true }
    );

  const credentials: ClientCredential[] = (data?.data || []).map((row) => ({
    id: Number(row.id),
    name: row.attributes.name,
    redirectUri: row.attributes["redirect-uri"] ?? "",
    clientId: row.attributes["client-id"] ?? "",
    clientSecret: row.attributes["client-secret"] ?? "",
  }));

  return { credentials, isLoading, isFetching, error, refetch };
};

export default useListClientCredentials;
